import { formatDistanceToNowStrict } from "date-fns";

interface ITopMessageLastSeenFields {
  daysSeen: number;
  lastSeen?: string;
  dateLastSeen?: string;
  LastSeen?: string;
  DateLastSeen?: string;
}

export function parseTopMessageDate(value?: string): Date | null {
  if (!value) {
    return null;
  }

  const normalizedDate = value.trim().replace(" ", "T").replace(/\.(\d{3})\d+/, ".$1");
  const parsedDate = new Date(normalizedDate);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function getTopMessageLastSeenDate(
  message: ITopMessageLastSeenFields,
  fallbackReferenceDate: Date
): Date | null {
  const explicitLastSeen = parseTopMessageDate(
    message.lastSeen || message.dateLastSeen || message.LastSeen || message.DateLastSeen
  );

  if (explicitLastSeen) {
    return explicitLastSeen;
  }

  if (typeof message.daysSeen === "number" && message.daysSeen >= 0) {
    return new Date(fallbackReferenceDate.getTime() - message.daysSeen * 24 * 60 * 60 * 1000);
  }

  return null;
}

function formatDaysSeen(days: number): string {
  if (days < 1) {
    const hours = Math.round(days * 24);
    return hours === 1 ? "1 hour" : `${hours} hours`;
  }

  if (days < 7) {
    const roundedDays = Math.round(days);
    return roundedDays === 1 ? "1 day" : `${roundedDays} days`;
  }

  const weeks = Math.round(days / 7);
  return weeks === 1 ? "1 week" : `${weeks} weeks`;
}

export function formatTopMessageLastSeen(
  message: ITopMessageLastSeenFields,
  fallbackReferenceDate: Date
): string {
  const parsedLastSeen = getTopMessageLastSeenDate(message, fallbackReferenceDate);
  if (parsedLastSeen) {
    return formatDistanceToNowStrict(parsedLastSeen, { addSuffix: true });
  }

  if (message.daysSeen === 0) {
    return "just now";
  }

  return message.daysSeen > 0 ? `${formatDaysSeen(message.daysSeen)} ago` : "";
}
